import { getChatsV2 } from './getChatsV2';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';
import { EChatListTrigger } from '../../utils/logging/publicApiDiagnostics';

export const getChatListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestamp = chatList.isFirstLoad
    ? undefined
    : chatList.chats.length
      ? getLastTimeStamp(chatList.chats)
      : state.chatList.timestamp;

  const trigger = chatList.isFirstLoad ? EChatListTrigger.FirstLoad : EChatListTrigger.NextPage;

  dispatch(getChatsV2({ timestamp }, trigger));
};
